import { render, staticRenderFns } from "./AssessReport.vue?vue&type=template&id=05fcf2f1&scoped=true"
import script from "./AssessReport.vue?vue&type=script&lang=js"
export * from "./AssessReport.vue?vue&type=script&lang=js"
import style0 from "./AssessReport.vue?vue&type=style&index=0&id=05fcf2f1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05fcf2f1",
  null
  
)

export default component.exports